// extracted by mini-css-extract-plugin
module.exports = {"section_blog_registration":"blog_registration_section_blog_registration__3Oc1r"};